<div class="relative flex items-center gap-[0.5rem] bg-(--p-neutral-500) rounded-t-[0.5rem] rounded-br-[0.5rem] !rounded-bl-0 p-[0.5rem]">
  <span class="text-[0.75rem] font-[600] text-(--p-gray-950) leading-[150%]">
    {{ name() }}
  </span>
  <span class="w-px h-auto self-stretch bg-(--p-gray-100) shrink-0"></span>
  <span class="text-[0.75rem] font-[500] text-(--p-gray-600) leading-[150%]">
    {{ date() }}
  </span>
  <div class="absolute -bottom-2 left-0
    w-0 h-0
    border-l-0
    border-r-[0.625rem] border-r-transparent
    border-t-[0.625rem] border-t-(--p-neutral-500)">
  </div>
</div>
